import React from 'react';

import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';

import { REVIEW_TEXTS } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import ReviewsPendingOnOthersAGGrid from './ReviewsPendingOnOthersAGGrid';
import { useReviewFormsList } from './hooks/dataHooks';

const ReviewsPendingOnOthers = ({ selectedTableRef, selectedTableId, selectedReviewCycleId }) => {
  const { data: reviewsListData, isLoading } = useReviewFormsList({
    reviewCycleId: selectedReviewCycleId,
    sectionId: selectedTableId,
    reactQueryKey: REACT_QUERY_KEYS.reviewsLanding.pendingOnOthers,
  });

  const tableDataColumns = reviewsListData?.data?.columns ?? [];
  const tableDataValues = reviewsListData?.data?.values ?? [];
  const queryClient = useQueryClient();

  const removeFromReviewsList = (reviewId, employeeId) => {
    queryClient.setQueryData(
      [REACT_QUERY_KEYS.reviewsLanding.pendingOnOthers, selectedTableId, selectedReviewCycleId],
      (prev) => {
        const newData = produce(prev, (draft) => {
          draft.data.values = draft.data.values.filter(
            (r) =>
              r['1'].reviewItem.review.feedbackForm.id !== reviewId ||
              r['1'].reviewItem.review.providerEmployeeId !== employeeId
          );
        });
        return newData;
      }
    );
  };

  return (
    <ReviewsPendingOnOthersAGGrid
      selectedTableRef={selectedTableRef}
      columns={tableDataColumns}
      rows={tableDataValues}
      selectedTableId={selectedTableId}
      removeFromReviewsList={removeFromReviewsList}
      errorMessage={REVIEW_TEXTS.LANDING_PAGE_REVIEWS_TO_COMPLETE.ERROR_MSG}
      loading={isLoading}
    />
  );
};

export default ReviewsPendingOnOthers;
